import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className=" w-full h-screen flex justify-center items-center p-4  "
    >
      <form
        action="https://getform.io/f/1b83d42a-ab22-4d1f-b1b1-06ad68e17e8c"
        method="POST"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="">
          <p className="text-4xl   font-bold inline border-b-4 border-[#008037]">
            Contact me
          </p>
          <p className="py-4">//Submit the form beliw or shoot me e-mail</p>
        </div>
        <input
          className="my-2 p-2 bg-gray-300  text-black"
          type="text"
          placeholder="Name"
          name="name"
        />
        <input
          className="my-2 p-2 bg-gray-300  text-black"
          type="email"
          placeholder="E-mail"
          name="email"
        />
        <textarea
          className="bg-gray-300 text-black my-2 p-2"
          name="message "
          id=""
          cols="30"
          rows="10"
          placeholder="Enter Your message here"
        ></textarea>
        <button className="  border-2 flex max-w-fit px-6 py-3 my-2 items-center justify-between hover:bg-[#008037] border-[#008037] duration-200 ">
          Let's Collaborate
        </button>
      </form>
    </div>
  );
};

export default Contact;
